import { Helmet } from 'react-helmet-async';

export default function Policy() {
	return (
		<>
			<Helmet>
				<title>Policy</title>
			</Helmet>

			<section className="container">
				<h1>Privacy Policy</h1>
				<h3>Who we are</h3>
				<p>Our website address is: https://Gersem </p>

				<h3>Comments</h3>
				<p>When visitors leave comments on the site we collect the data shown in the comments form, and also the visitor's IP address and browser user agent string to help spam detection.</p>

				<h3>Average</h3>
				<p>If you upload images to the website, you should avoid uploading images that include embedded location data (EXIF GPS). Website visitors can download and extract any location data from images on the website.</p>

				<h3>Cookies</h3>
				<p>If you leave a comment on our site you may choose to save your name, email address and website in cookies. They are used for your convenience so that you do not have to re-enter your details when you leave another comment. These cookies will last for one year.</p>

				<h3>Embedded content from other websites</h3>
				<p>Articles on this site may include embedded content (e.g. videos, images, articles, etc.). Embedded content from other websites behaves in exactly the same way as if the visitor had visited the other website.</p>
				<p>These websites may collect data about you, use cookies, embed additional third-party tracking, and monitor your interaction with them, including tracking your interaction with the embedded content if you have an account and are logged in to those websites.</p>

				<h3>How long we keep your data</h3>
				<p>If you leave a comment, the comment and its metadata are retained indefinitely. This is so we can automatically recognize and approve any subsequent comments instead of keeping them in a moderation queue.</p>
				<p>For users who register on our website (if any), we also store the personal information they provide in their user profile. All users can see, edit or delete their personal information at any time (except their username which they cannot change). Website administrators can also see and edit this information.</p>

				<h3>What rights do you have over your data</h3>
				<p>If you have an account on this site, or have left comments, you can request to receive an exported file of the personal data we hold about you, including any data you have provided to us. You can also request that we delete all personal data relating to you. This does not include data that we are obliged to keep for administrative, legal or security purposes.</p>
			</section>
		</>
	);
}
